export * from "./previous-route.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/previous-route/index.ts